import { Box, styled } from '@mui/material';

export const Wrapper = styled(Box)(() => ({
	display: 'flex',
	flexDirection: 'column',
	gap: '8px',
	flex: '1',
	justifyContent: 'center',
}));
